import { Component } from '@angular/core';
import { ResourceListComponent } from '../../shared/resource-list/resource-list.component';

@Component({
  selector: 'app-knowledge',
  standalone: true,
  imports: [ResourceListComponent],
  template: `<app-resource-list title="Knowledge" apiPath="v1/knowledge" />`
})
export class KnowledgeComponent {}
